export default "__VITE_ASSET__2f3e49ee__"